import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, clearWorkshopCode, setWorkshopCode } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [workshop, setWorkshop] = useState(null); // null=loading, false=logged-out, obj=logged-in
  const [refreshing, setRefreshing] = useState(false);

  const refresh = useCallback(async () => {
    // If returning from Google OAuth, let AuthCallback handle it first
    if (window.location.hash?.includes("session_id=")) {
      setWorkshop((prev) => (prev === null ? false : prev));
      return;
    }
    setRefreshing(true);
    try {
      const { data } = await api.get("/auth/me");
      setWorkshop(data);
      if (data?.code) setWorkshopCode(data.code); // keep legacy header as fallback
    } catch {
      setWorkshop(false);
    } finally {
      setRefreshing(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = (data) => {
    setWorkshop(data);
    if (data?.code) setWorkshopCode(data.code);
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    clearWorkshopCode();
    setWorkshop(false);
    // Send user back to landing
    if (typeof window !== "undefined") {
      window.location.href = "/";
    }
  };

  return (
    <AuthContext.Provider value={{ workshop, setWorkshop: login, logout, refresh, refreshing }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
